export const LOT_MIGRATOR_MAX_LENGTHS = {
    dpNumber: 100,
    street: 150,
    suburb: 150,
    city: 150,
    postCode: 4
} as const;
